import getSundaysForCurrentAndNextYear from './getSundaysForCurrentAndNextYear';
import { LOCALE_DATE_FORMAT } from './returnDateCalculator/constants';

const closedDatesCalculator = (
    closedDates: string[],
    targetDate: string
): {
    isInArray: boolean;
    consecutiveDays: number;
    nextOpenDay: Date | null;
} => {
    const sundays = getSundaysForCurrentAndNextYear();
    closedDates.push(...sundays);

    // Convert strings to Date objects and sort in ascending order
    const sortedDates = closedDates
        .map((date) => new Date(date.split('/').reverse().join('-'))) // Convert 'DD/MM/YYYY' to 'YYYY-MM-DD'
        .filter((date) => !isNaN(date.getTime())) // Filter out invalid dates
        .sort((a, b) => a.getTime() - b.getTime()); // Sort dates in ascending order

    // Find the index of the target date
    const targetIndex = sortedDates.findIndex(
        (date) =>
            date.toISOString().split('T')[0] ===
            targetDate.split('/').reverse().join('-')
    );

    // Check if target date is in the array
    if (targetIndex === -1) {
        return {
            isInArray: false,
            consecutiveDays: 0,
            nextOpenDay: null,
        };
    }

    // Count consecutive days after the target date
    let consecutiveDays = 0; // Start with 1 since we include the target date itself
    for (let i = targetIndex + 1; i < sortedDates.length; i++) {
        const currentDate = sortedDates[i];
        const previousDate = sortedDates[i - 1];
        const dayDifference =
            (currentDate.getTime() - previousDate.getTime()) /
            (1000 * 60 * 60 * 24);

        if (dayDifference === 1) {
            consecutiveDays++;
        } else {
            break;
        }
    }

    const dateChosen = new Date(targetDate.split('/').reverse().join('-'));

    const nextOpenDay = new Date(
        dateChosen.setDate(dateChosen.getDate() + consecutiveDays + 1)
    ).toLocaleDateString(LOCALE_DATE_FORMAT);

    return {
        isInArray: true,
        consecutiveDays,
        nextOpenDay: nextOpenDay as unknown as Date,
    };
};

export default closedDatesCalculator;
